
export enum PlanTypes {
  PrepaidCard = 'prepaidCard',
  Month = 'monthly',
  Year = 'yearly',
  Life = 'lifetime',
}

export interface Plan {
  id: string;
  type: PlanTypes;
  price?: number;
  imageName: string;
  canActivateFamilyOption: boolean;
}

export interface FamilyOptionPlan {
  id: string | null;
  price: number;
}